

// Needed for pluton
function gotoLink(htmlElement) {

    var destinationUrl = "";
    var target = "";

    if (htmlElement.href) {
        destinationUrl = htmlElement.href;
        target = htmlElement.getAttribute("target");
    }
    else {
        if (htmlElement.childNodes) {
            if (htmlElement.getElementsByTagName("a")) {
                destinationUrl = htmlElement.getElementsByTagName("a")[0].href;
                target = htmlElement.getElementsByTagName("a")[0].getAttribute("target");
            }
        }
    }

    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        var referLink = document.createElement('a');
        referLink.href = destinationUrl;
        referLink.target = target;
        document.body.appendChild(referLink);
        referLink.click();
    } else if (target === "_blank") {
        window.open(destinationUrl);
    }
    else {
        location.href = destinationUrl;
    }
}


// ie fix (add class ie{version} to <html>)
(function (document) {
    /**
     * documentMode is an IE-only property
     * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
     */
    var msie = parseInt(document.documentMode);
    if (msie) {
        document.getElementsByTagName("html")[0].className += " ie" + msie;
    }
})(document);


// detect touch devices
(function (window) {
    window.isTouchDevice = false;

    // https://codeburst.io/the-only-way-to-detect-touch-with-javascript-7791a3346685
    $(window).one("touchstart", function () {
        window.isTouchDevice = true;
    });

})(window);
